import React, { useRef } from 'react';
import format from 'date-fns/format';
import { IconButton } from '../../../icon-button';
import { Icon } from '../../../icon';
import { Body1 } from '../../../typography';
import { MonthsDropdown } from './months-dropdown';
import { YearsDropdown } from './years-dropdown';
import { DropdownsContext } from './utils/dropdowns-context';
import { createEventBus } from './utils/event-bus';
import { StyledHeader } from './styled';
const headerDateFormat = {
    year: 'yyyy',
    quarter: 'yyyy',
    month: 'MMMM',
    day: 'MMMM yyyy'
};
export const Header = ({ decreaseMonth, increaseMonth, increaseYear, decreaseYear, calendarRef, monthDate, date, showMonthDropdown, showYearDropdown, changeMonth, changeYear, periodType, prevYearButtonDisabled, prevMonthButtonDisabled, nextMonthButtonDisabled, nextYearButtonDisabled, ...props }) => {
    const dateFormat = headerDateFormat[periodType || 'day'];
    const dropdownsEventBus = useRef(createEventBus());
    const formattedDate = format(date, dateFormat);
    const isYearFormat = dateFormat === 'yyyy';
    const increase = isYearFormat ? increaseYear : increaseMonth;
    const decrease = isYearFormat ? decreaseYear : decreaseMonth;
    const nextDisabled = isYearFormat ? nextYearButtonDisabled : nextMonthButtonDisabled;
    const prevDisabled = isYearFormat ? prevYearButtonDisabled : prevMonthButtonDisabled;
    let dropdown = React.createElement(Body1, null, formattedDate);
    if (showMonthDropdown && !showYearDropdown) {
        dropdown = (React.createElement(MonthsDropdown, { changeMonth: changeMonth, calendarRef: calendarRef, monthDate: monthDate, ...props }, formattedDate));
    }
    else if (showYearDropdown && !showMonthDropdown) {
        dropdown = (React.createElement(YearsDropdown, { changeYear: changeYear, calendarRef: calendarRef, monthDate: monthDate || date, ...props }, formattedDate));
    }
    else if (showYearDropdown && showMonthDropdown && !isYearFormat) {
        const formattedMonth = format(date, headerDateFormat.month);
        const formattedYear = format(date, headerDateFormat.year);
        dropdown = (React.createElement(React.Fragment, null,
            React.createElement(MonthsDropdown, { changeMonth: changeMonth, calendarRef: calendarRef, monthDate: monthDate, ...props }, formattedMonth),
            React.createElement(YearsDropdown, { changeYear: changeYear, calendarRef: calendarRef, monthDate: monthDate, ...props }, formattedYear)));
    }
    return (React.createElement(DropdownsContext.Provider, { value: { dropdownOpenedEB: dropdownsEventBus.current } },
        React.createElement(StyledHeader, null,
            React.createElement(IconButton, { onClick: decrease, title: "Previous Month", disabled: prevDisabled },
                React.createElement(Icon, { name: "arrow_back" })),
            dropdown,
            React.createElement(IconButton, { onClick: increase, title: "Next Month", disabled: nextDisabled },
                React.createElement(Icon, { name: "arrow_forward" })))));
};
